"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ThemeProvider = require("../ThemeProvider");
var _utils = require("../utils");
var _Icon = _interopRequireDefault(require("../Icon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _utils.selectSystemProps)([_utils.a11yProps, _utils.viewProps]);
const selectInnerContainerStyles = _ref => {
  let {
    borderRadius,
    width,
    backgroundColor
  } = _ref;
  return {
    borderRadius,
    width,
    backgroundColor
  };
};
const selectIconTokens = _ref2 => {
  let {
    iconSize,
    iconColor,
    iconScale = 1
  } = _ref2;
  return {
    size: iconSize,
    color: iconColor,
    scale: iconScale
  };
};

/**
 * `TooltipButton` is a helper component used as a default control for the `Tooltip` component.
 * In fact though, it isn't actually a pressable - it's meant to be used as pressable's content.
 * Due to this any interaction states (e.g. pressed, hover, etc.) has to be passed down to it as a prop.
 */
const TooltipButton = /*#__PURE__*/_react.default.forwardRef((_ref3, ref) => {
  let {
    pressableState,
    tokens,
    variant,
    ...rest
  } = _ref3;
  const themeTokens = (0, _ThemeProvider.useThemeTokens)('TooltipButton', tokens, variant, pressableState);
  const {
    icon: IconComponent
  } = themeTokens;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
    style: [(0, _ThemeProvider.applyOuterBorder)(themeTokens), themeTokens.outerBorderWidth && {
      margin: -themeTokens.outerBorderWidth
    }, staticStyles.bubblePointerEvents],
    ...selectProps(rest),
    ref: ref,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
      style: selectInnerContainerStyles(themeTokens),
      children: IconComponent && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        icon: IconComponent,
        tokens: selectIconTokens(themeTokens)
      })
    })
  });
});
TooltipButton.displayName = 'TooltipButton';
const staticStyles = _StyleSheet.default.create({
  bubblePointerEvents: {
    ..._Platform.default.select({
      web: {
        pointerEvents: 'none'
      }
    })
  }
});
TooltipButton.propTypes = {
  ...selectedSystemPropTypes,
  /**
   * Used as appearances when resolving theme tokens.
   */
  pressableState: _propTypes.default.shape({
    pressed: _propTypes.default.bool,
    hover: _propTypes.default.bool,
    focus: _propTypes.default.bool
  }),
  tokens: (0, _utils.getTokensPropType)('TooltipButton'),
  variant: _utils.variantProp.propType
};
var _default = exports.default = TooltipButton;